import React from 'react';

import { TCanProps } from '@/shared/features/permissions/components/can/can.types';
import { usePermissionCheck } from '@/shared/features/permissions/hooks/use-permission-check/use-permission-check';

export const Can: React.FC<TCanProps> = ({
  action,
  ids,
  any = false,
  children,
  fallback = null,
}) => {
  const { can, canAny, isLoading } = usePermissionCheck();

  if (isLoading) {
    return null;
  }

  const allowed = any ? canAny(action, ids) : can(action, ids);

  return <>{allowed ? children : fallback}</>;
};
